<template>
  <div class="content md flex-box vertical">
    <div class="implement-count">
      <a-card :bordered="false" :title="`${config.name}数据`">
        <div class="piece-area-ctx flex-box align-center justify-between">
          <div class="piece-view">
            <div class="piece-view-value">{{ config.count.total }}</div>
            <div class="piece-view-title">{{ config.name }}设备数量</div>
          </div>
          <div class="piece-view">
            <div class="piece-view-value">{{ config.count.online }}</div>
            <div class="piece-view-title">设备在线</div>
          </div>
          <div class="piece-view">
            <div class="piece-view-value">{{ (config.count.online / config.count.total * 100).toFixed(2) }}%</div>
            <div class="piece-view-title">设备在线率</div>
          </div>
        </div>
      </a-card>
    </div>
    <data-list
      ref="dataList"
      class="flex-grow"
      :data="config.list"
      :entity-name="config.name"
      :add-btn="false"
      hide-show-detail
      hide-delete
      hide-edit
      :columns="columns"
      :search-key-type="{ name: 1 }"
    >
      <template v-slot:action>
        <a class="txt-btn">开/关</a>
        <a class="txt-btn">编辑</a>
        <a class="txt-btn">权限管理</a>
      </template>
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.name" placeholder="输入设备名称、设备编号搜索" allowClear style="width: 240px"></a-input>
        </a-form-model-item>
      </template>
    </data-list>
  </div>
</template>

<script>
import implement from "./implement";
import {doorStatusOptions} from "@/common/constant/space";
export default {
  name: "ImplementPage",
  props: {
    type: String
  },
  data() {
    return {
      columns: [
        { title: "设备名称", dataIndex: "name" },
        { title: "设备编号", dataIndex: "no" },
        {
          title: "在线状态",
          dataIndex: "status",
          customRender: (text) => {
            let item = doorStatusOptions.find((option) => option.value === text);
            return item ? <span style={{ color: item.color }}>{item.label}</span> : "-";
          },
        },
        { title: "关联办公室、会议室", dataIndex: "office" },
      ]
    }
  },
  computed: {
    config() {
      return implement[this.type] || {};
    }
  },
  methods: {},
};
</script>

<style lang="less" scoped>
@import url("../../../common/less/safe.less");

.implement-count {
  flex-shrink: 0;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
}

</style>
